/* Pulses the header cart icon when the cart count increases. The cart JS
   re-renders #cart-icon-bubble's contents after every cart change, so a
   MutationObserver on it fires exactly when the cart updates. */
(() => {
  const init = () => {
    const icon = document.getElementById('cart-icon-bubble');
    if (!icon || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const count = () => {
      const bubble = icon.querySelector('.cart-count-bubble span[aria-hidden]');
      return bubble ? parseInt(bubble.textContent, 10) || 0 : 0;
    };

    let last = count();
    const observer = new MutationObserver(() => {
      const now = count();
      if (now > last) {
        icon.classList.remove('esc-cart-pulse');
        void icon.offsetWidth; /* restart the animation if it's mid-flight */
        icon.classList.add('esc-cart-pulse');
      }
      last = now;
    });
    observer.observe(icon, { childList: true, subtree: true });

    icon.addEventListener('animationend', () => icon.classList.remove('esc-cart-pulse'));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
